<template>
  <div class="row g-4">
    <div class="col-lg-3 col-6">
      <div class="form-field"><label class="field-label">الأيقونة</label><InputText v-model="local.icon" class="w-100" /></div>
    </div>
    <div class="col-lg-4 col-6">
      <div class="form-field"><label class="field-label">العنوان</label><InputText v-model="local.title" class="w-100" /></div>
    </div>
    <div class="col-lg-5 col-12">
      <div class="form-field"><label class="field-label">الوصف الفرعي</label><InputText v-model="local.subtitle" class="w-100" /></div>
    </div>
    <div class="col-lg-6 col-12">
      <div class="form-field">
        <label class="field-label">الزر الرئيسي</label>
        <div class="stat-row">
          <InputText v-model="local.primary.label" placeholder="النص" class="w-100" />
          <InputText v-model="local.primary.link" placeholder="الرابط" class="w-100" />
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-12">
      <div class="form-field">
        <label class="field-label">زر واتساب</label>
        <div class="stat-row">
          <InputText v-model="local.whatsapp.label" placeholder="النص" class="w-100" />
          <InputText v-model="local.whatsapp.url" placeholder="الرابط" class="w-100" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, watch } from 'vue';
import InputText from 'primevue/inputtext';

const props = defineProps({ modelValue: { type: Object, default: () => ({}) } });
const emit = defineEmits(['update:modelValue']);

const local = reactive({
  icon: props.modelValue.icon ?? '',
  title: props.modelValue.title ?? '',
  subtitle: props.modelValue.subtitle ?? '',
  primary: { ...(props.modelValue.primary ?? { label: '', link: '' }) },
  whatsapp: { ...(props.modelValue.whatsapp ?? { label: '', url: '' }) },
});

watch(local, () => emit('update:modelValue', { ...props.modelValue, ...local }), { deep: true });
</script>

<style scoped>
.stat-row { display: grid; grid-template-columns: 1fr 1fr; gap: .5rem; }
</style>
